"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var button_1 = tslib_1.__importDefault(require("../button"));
var config_provider_1 = require("../config-provider");
var DirectionDown_1 = require("../Icons/DirectionDown");
var dropdown_1 = tslib_1.__importDefault(require("./dropdown"));
var ButtonGroup = button_1.default.Group;
var DropdownButton = function (props) {
    var _a = React.useContext(config_provider_1.ConfigContext), getContextPopupContainer = _a.getPopupContainer, getPrefixCls = _a.getPrefixCls, direction = _a.direction;
    var customizePrefixCls = props.prefixCls, type = props.type, disabled = props.disabled, onClick = props.onClick, htmlType = props.htmlType, children = props.children, className = props.className, overlay = props.overlay, trigger = props.trigger, align = props.align, visible = props.visible, onVisibleChange = props.onVisibleChange, placement = props.placement, getPopupContainer = props.getPopupContainer, href = props.href, _b = props.icon, icon = _b === void 0 ? React.createElement(DirectionDown_1.DirectionDown, null) : _b, title = props.title, buttonsRender = props.buttonsRender, restProps = tslib_1.__rest(props, ["prefixCls", "type", "disabled", "onClick", "htmlType", "children", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender"]);
    var prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
    var dropdownProps = {
        align: align,
        overlay: overlay,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onVisibleChange: onVisibleChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
    };
    var buttonGroupRef = React.useRef();
    if ('visible' in props) {
        dropdownProps.visible = visible;
    }
    if ('placement' in props) {
        dropdownProps.placement = placement;
    }
    else {
        dropdownProps.placement = direction === 'rtl' ? 'bottomLeft' : 'bottomRight';
    }
    var leftButton = (React.createElement(button_1.default, { type: type, disabled: disabled, onClick: onClick, htmlType: htmlType, href: href, title: title }, children));
    var rightButton = React.createElement(button_1.default, { className: "".concat(prefixCls, "-right-action"), type: type, icon: icon });
    var _c = tslib_1.__read(buttonsRender([leftButton, rightButton]), 2), leftButtonToRender = _c[0], rightButtonToRender = _c[1];
    var _d = tslib_1.__read(React.useState(0), 2), overlayWidth = _d[0], setOverLayWidth = _d[1];
    React.useEffect(function () {
        if (buttonGroupRef.current) {
            setOverLayWidth(buttonGroupRef.current.getBoundingClientRect().width);
        }
    }, []);
    return (React.createElement(ButtonGroup, tslib_1.__assign({}, restProps, { ref: buttonGroupRef, className: (0, classnames_1.default)(prefixCls, className) }),
        leftButtonToRender,
        React.createElement(dropdown_1.default, tslib_1.__assign({}, dropdownProps, { overlayStyle: tslib_1.__assign({ width: "".concat(overlayWidth, "px") }, (dropdownProps.overlayStyle || {})), className: (0, classnames_1.default)(dropdownProps.className, "".concat(prefixCls, "-action-overlay")) }), rightButtonToRender)));
};
DropdownButton.__ANT_BUTTON = true;
DropdownButton.defaultProps = {
    type: 'primary',
    buttonsRender: function (buttons) { return buttons; },
    placement: 'bottomRight',
};
exports.default = DropdownButton;
//# sourceMappingURL=dropdown-button.js.map